import script from "./PaginationDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaginationDetails.vue?vue&type=script&lang=ts&setup=true"

import "./PaginationDetails.vue?vue&type=style&index=0&id=d199b42a&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d199b42a"]])

export default __exports__